var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 11.125H6.54688V6.90039C6.54688 5.30078 7.81836 3.94727 9.45898 3.90625C11.0996 3.90625 12.4531 5.25977 12.4531 6.85938V7.51562C12.4531 8.08984 12.8633 8.5 13.4375 8.5H14.75C15.2832 8.5 15.7344 8.08984 15.7344 7.51562V6.85938C15.7344 3.41406 12.9043 0.625 9.45898 0.625C6.01367 0.666016 3.26562 3.49609 3.26562 6.94141V11.125H2.28125C1.17383 11.125 0.3125 12.0273 0.3125 13.0938V19.6562C0.3125 20.7637 1.17383 21.625 2.28125 21.625H16.7188C17.7852 21.625 18.6875 20.7637 18.6875 19.6562V13.0938C18.6875 12.0273 17.7852 11.125 16.7188 11.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.8ecca622a1d1af268d8c58ced653631e.svg";
export { ForwardRef as ReactComponent };